import { useState, useEffect, useRef, useCallback } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export function useGetAllTrucks() {
  const [trucks, setTrucks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  // Fetch all trucks
  const fetchAllTrucks = useCallback(async (signal) => {
    if (mountedRef.current) {
      setLoading(true);
      setError(null);
    }

    try {
      const res = await API.get('/trucks', { signal });
      if (mountedRef.current) setTrucks(res?.data || []);
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') return;
      console.error('Failed to fetch trucks:', err);
      if (mountedRef.current)
        setError(translateApiError(err, 'Failed to fetch trucks'));
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  // Fetch trucks on mount
  useEffect(() => {
    const controller = new AbortController();
    fetchAllTrucks(controller.signal);

    return () => {
      mountedRef.current = false;
      controller.abort();
    };
  }, [fetchAllTrucks]);

  // Refetch function (for manual refresh)
  const refetch = useCallback(() => {
    const controller = new AbortController();
    fetchAllTrucks(controller.signal);
    return () => controller.abort();
  }, [fetchAllTrucks]);

  return { trucks, loading, error, refetch };
}
